// extracted by mini-css-extract-plugin
module.exports = {"image":"hero-scroll_image__hJ6Kj","reveal":"hero-scroll_reveal__7Ukcb","logoFade":"hero-scroll_logoFade__YWOPJ"};